import { render, staticRenderFns } from "./SupplierDirectory.vue?vue&type=template&id=12d10d58&scoped=true&"
import script from "./SupplierDirectory.vue?vue&type=script&lang=js&"
export * from "./SupplierDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d10d58",
  null
  
)

export default component.exports